import { useEffect } from 'react';

interface IElementBottomPositionHook {
  id: string;
  value: string;
  defaultValue: string;
}

const useElementBottomPosition = ({ id, value, defaultValue }: IElementBottomPositionHook) => {
  useEffect(() => {
    const element = document.getElementById(id);
    if (element) {
      element.style.bottom = value;
    }
    return () => {
      if (element) {
        element.style.bottom = defaultValue;
      }
    };
  }, []);
};

export default useElementBottomPosition;

export const SNACKBAR_POSITION = {
  id: 'snackbar',
  value: '7.5rem',
  defaultValue: '2rem',
};
